// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZywTXM{display:flex;justify-content:center;align-items:center;height:100%;padding:0 60px}.iI5Czx{width:100%;height:100%}.xnqbeM{position:absolute;left:0;right:0;overflow:visible}.pCFoWp{height:inherit}.PdIdZr{padding:0 8px}.Cm_SnZ,._7Jv_tR{top:0;height:100%;flex-grow:1;transition:opacity 0.3s;color:#ffffff}.Cm_SnZ:hover,._7Jv_tR:hover{opacity:0.6}.Cm_SnZ svg,._7Jv_tR svg{width:10px}.Cm_SnZ{text-align:right;padding-right:20px}._7Jv_tR{text-align:left;padding-left:20px}._7Jv_tR svg{transform:scaleX(-1);filter:FlipH;-ms-filter:"FlipH"}div[data-vod-player-min-width~="350px"] .iI5Czx{height:180px}div[data-vod-player-min-width~="460px"] .iI5Czx{height:230px}div[data-vod-player-min-width~="601px"] .iI5Czx{height:292px}div[data-vod-player-min-width~="981px"] .ZywTXM{padding:0 130px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ZywTXM`,
	"content": `iI5Czx`,
	"animate": `xnqbeM`,
	"slider": `pCFoWp`,
	"item": `PdIdZr`,
	"prev": `Cm_SnZ`,
	"next": `_7Jv_tR`
};
export default ___CSS_LOADER_EXPORT___;
